import React, { Component } from 'react'
import SocialShare from '../../atoms/SocialShare'
import Icon from '../../atoms/FontIcon'
import { Row, Col } from '../../atoms/Grid'
import style from './style.css'
export default class ShareBar extends Component {
   render() {
      return (
         <div className={style.bar}>
            <Col size={`12 6`} float={`center`}>
               <Row>
                  <Col size={`12 7`} text={`center right`}>
                     <div className={style.text}>
                        Gostou? Então compartilhe!
                     </div>
                  </Col>
                  <Col size={`12 5`} text={`center left`}>
                     <Row>
                        <SocialShare type='Facebook'>
                           <div className={style.icon}>
                              <Icon name='facebook' size={30} color='#666' />
                           </div>
                        </SocialShare>
                        <SocialShare type='Twitter'>
                           <div className={style.icon}>
                              <Icon name='twitter' size={30} color='#666' />
                           </div>
                        </SocialShare>
                     </Row>
                  </Col>
               </Row>
            </Col>
         </div>
      )
   }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/molecules/ShareBar/index.js